import PropTypes from 'prop-types';
import clsx from 'clsx';

const defaultProps = {
  className: null,
};

const propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default function FormGroup({
  className,
  children,
}) {
  return (
    <div className={clsx('form-group space-y-2', className)}>
      {children}
    </div>
  );
}

FormGroup.defaultProps = defaultProps;
FormGroup.propTypes = propTypes;
